"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$ui = void 0;

var _variables = _interopRequireDefault(require("../variables"));

var _utilities = require("./_utilities");

var _style = require("./style");

var $ui = function () {
  var APIs = {},
      set = _style.$style.set,
      remove = _style.$style.remove;

  APIs.blockScroll = function (action) {
    switch (action) {
      case 'enable':
        var sbw = _variables["default"].scrollbarWidth;
        set(document.body, {
          overflow: 'hidden',
          paddingRight: sbw + 'px'
        });
        break;

      case 'disable':
        remove(document.body, 'overflow, padding-right');
        break;

      default:
        (0, _utilities.warn)('Missing argument in blockScroll function', '$ui-helper');
    }
  };

  return APIs;
}(window);

exports.$ui = $ui;